<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="dialogTitle"
    width="50%"
    :before-close="handleClose"
  >
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="120px"
    >
      <el-form-item label="题型" prop="type">
        <el-radio-group
          v-model="formData.type"
          :disabled="formType == 'view'"
          @change="handleTypeChange"
        >
          <el-radio
            v-for="item in OQuestionType"
            :label="item.value"
            :key="item.value"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>

      <el-form-item label="题目" prop="title">
        <el-input
          v-model="formData.title"
          placeholder="填写题干"
          style="width: 400px"
          type="textarea"
          maxlength="300"
          rows="4"
          :disabled="formType == 'view'"
        ></el-input>
      </el-form-item>

      <div
        class="flex list_box"
        v-for="(item, index) in formData.titleOptionJson"
        :key="index"
      >
        <div class="flex align-items">
          <span class="video_span"
            ><span style="color: #f56c6c" v-if="index == 0">* </span>
            <span class="marginLeft10" v-if="index == 0">选项</span>
          </span>
          <div class="marginRight10">{{ item.num }}</div>
          <el-input
            v-model="item.name"
            placeholder="请输入"
            style="width: 400px"
            maxlength="30"
            :disabled="formType == 'view'"
          ></el-input>
          <i
            class="el-icon-delete marginLeft10 del_icon"
            @click="removeOption(index)"
            v-if="formData.titleOptionJson.length > 2"
          ></i>
        </div>
      </div>
      <el-button
        size="medium"
        type="primary"
        @click="addOption"
        icon="el-icon-plus"
        class="addBtn"
        v-if="formData.titleOptionJson.length < 10"
        >增加选项</el-button
      >
      <div class="daAn_box">
        <div class="label_span">
          <div style="color: #f56c6c">*</div>
          <div class="marginLeft10">答案</div>
        </div>

        <div class="daAn_list">
          <div
            class="daAn_item"
            v-for="(item, index) in formData.titleOptionJson"
            :key="index"
            :class="{ daAn_item_active: formData.answer.includes(item.num) }"
            @click="handleAnswer(index)"
          >
            {{ item.num }}
          </div>
        </div>
      </div>
    </el-form>
    <template #footer>
      <div class="flex" style="justify-content: center">
        <el-button
          :disabled="formLoading"
          type="primary"
          @click="submitForm"
          v-if="formType != 'view'"
          >保 存</el-button
        >
        <el-button @click="dialogVisible = false">
          {{ formType == "view" ? "关 闭" : "取 消" }}</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>
<script>
import { Message } from "element-ui";
import { questionManageAdd, questionManageUpdate } from "@/api/question/manage";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import { mobilePhoneRule } from "@/utils/formRules";
import dayjs from "dayjs";
import FormEditor from "@/components/formComponents/formEditor";
import FormVideoUpload from "@/components/formComponents/formVideoUpload";
import { EQuestionType, OQuestionType } from "@/enums/beCurrent/EBeCurrent";
export default {
  name: "index",
  components: {
    FormImgUpload,
    FormEditor,
    FormVideoUpload,
  },
  props: {},
  data() {
    return {
      EQuestionType,
      OQuestionType,
      dialogVisible: false, // 弹窗的是否展示
      dialogTitle: "", // 弹窗的标题
      formLoading: false, // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
      formType: "", // 表单的类型：create - 新增；update - 修改
      formData: {
        type: 1,
        title: "",
        answer: [], //答案
        titleOptionJson: [
          { num: "A", name: "", isAnswer: false },
          { num: "B", name: "", isAnswer: false },
        ], //接口需要转成对象提交
      },
      formRules: {
        title: [{ required: true, message: "请输入", trigger: "blur" }],
        abbr: [{ required: true, message: "请输入", trigger: "blur" }],
      },
    };
  },
  created() {},
  methods: {
    // const formRef = ref() // 表单 Ref
    /** 打开弹窗 */
    async open(type, item) {
      console.log(item, "zhe;li");
      this.dialogVisible = true;
      this.dialogTitle =
        type === "view" ? "详情" : type === "create" ? "新增" : "修改";
      this.formType = type;
      this.resetForm();
      // 修改时，设置数据
      if (item && item.id) {
        this.formLoading = true;
        try {
          const newData = { ...item };

          this.formData = {
            ...newData,
            titleOptionJson: Object.entries(newData.titleOptionJson).map(
              ([num, name]) => ({
                num,
                name,
              })
            ),
            answer: newData.answer.split(""),
          };
        } finally {
          this.formLoading = false;
        }
      }
    },
    async submitForm() {
      // 校验表单

      if (!this.$refs.formRef) return;
      // console.log(this.$refs.formRef.$refs.value, "zhe;li");
      const valid = await this.$refs.formRef.validate();

      if (!valid) return;
      // 判断选项值不能为空
      const emptyOptions = this.formData.titleOptionJson.filter(
        (item) => !item.name.trim()
      );
      if (emptyOptions.length > 0) {
        this.$message.error("选项内容不能为空");
        return;
      }
      // 判断答案不能为空
      if (this.formData.answer.length === 0) {
        this.$message.error("请选择答案");
        return;
      }
      // 如果是多选题(type=2)，判断答案至少选择两个
      if (
        this.formData.type == EQuestionType.multiple &&
        this.formData.answer.length < 2
      ) {
        this.$message.error("多选题答案至少需要选择两个选项");
        return;
      }

      try {
        this.formLoading = true;
        // 将选项数组转换为对象格式
        console.log(this.formData, "zhe;li");

        const optionsObject = {};
        this.formData.titleOptionJson.forEach((item) => {
          optionsObject[item.num] = item.name;
        });

        const newData = {
          ...this.formData,
          titleOptionJson: optionsObject,
          answer: this.formData.answer.join(""),
        };
        console.log(newData, "22222222222222");
        if (this.formType === "create") {
          const res = await questionManageAdd(newData);
          if (res.code == 200) {
            Message.success("新增成功");
          }
        } else {
          const res = await questionManageUpdate(newData);
          if (res.code == 200) {
            Message.success("修改成功");
          }
        }
        this.dialogVisible = false;
        // 发送操作成功的事件
        this.$emit("success");
        // setTimeout(() => {
        this.formLoading = false;
        // }, 1000);
      } catch (e) {
        // this.$message.error(e);
        this.formLoading = false;
      } finally {
      }
    },

    // 重置
    resetForm() {
      this.formData = {
        type: 1,
        title: "",
        answer: [],
        titleOptionJson: [
          { num: "A", name: "" },
          { num: "B", name: "" },
        ],
      };
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 增加选项
    addOption() {
      if (this.formData.titleOptionJson.length < 10) {
        this.formData.titleOptionJson.push({
          num: String.fromCharCode(65 + this.formData.titleOptionJson.length),
          name: "",
        });
      }
    },
    // 删除选项
    removeOption(index) {
      if (this.formData.titleOptionJson.length > 2) {
        this.formData.titleOptionJson.splice(index, 1);
        // 重新排序选项名称
        this.formData.titleOptionJson.forEach((item, idx) => {
          item.num = String.fromCharCode(65 + idx);
        });
      }
    },
    // 处理答案
    handleAnswer(index) {
      // 单选题
      if (this.formData.type === EQuestionType.single) {
        this.formData.answer = [this.formData.titleOptionJson[index].num];
        console.log(this.formData.answer, "zhe;li");
      } else if (this.formData.type === EQuestionType.multiple) {
        const num = this.formData.titleOptionJson[index].num;
        const answerIndex = this.formData.answer.indexOf(num);
        if (answerIndex > -1) {
          this.formData.answer.splice(answerIndex, 1);
        } else {
          this.formData.answer.push(num);
        }
      }
    },
    // 切换题型清空答案
    handleTypeChange(e) {
      this.formData.answer = [];
    },
  },
};
</script>
<style scoped lang="scss">
.list_box {
  margin-left: 3%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.video_icon {
  cursor: pointer;
  margin-top: 0.5%;
  margin-left: 10px;
}
.video_span {
  width: 80px;
  margin-left: 10px;
  display: inline-block;
}
/deep/.el-input__inner {
  text-align: left;
}

.addBtn {
  margin-left: 15%;
}

.daAn_box {
  margin-left: 3%;
  display: flex;
  align-items: center;
  .label_span {
    width: 80px;
    margin-left: 10px;
    display: flex;
    text-align: right;
    display: flex;
  }
  .daAn_list {
    display: flex;
    align-items: center;
    margin-top: 10px;

    .daAn_item {
      border: 1px solid #ddd;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      margin-right: 10px;
      cursor: pointer;
    }
    .daAn_item_active {
      background-color: #409eff;
      color: #fff;
    }
  }
}
.del_icon {
  font-size: 20px;
  cursor: pointer;
}
</style>
